import { pulseAxiosInstance } from "./axiosInstance";

export type Taxonomy = {
    id: number;
    title_no: string;
    title_en: string;
};

export const getTaxonomies = async (): Promise<Taxonomy[]> => {
    const response = await pulseAxiosInstance.get<Taxonomy[]>("/taxonomies");
    return response.data;
};
